import { Component, OnInit, ViewChild, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ListsService } from '../../../../core/lists/lists.service';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-popular-categories',
  templateUrl: './popular-categories.component.html',
  styleUrls: ['./popular-categories.component.scss']
})


export class PopularCategoriesComponent implements OnInit, AfterViewInit {
  // configuration
  public config: SwiperConfigInterface = {};
  public imageUrl: any;
  public CategoryList: any = [];
  public home :any;

  storename = '';

  constructor(private listService: ListsService,
  ) { }
  ngOnInit() {
    this.imageUrl = environment.imageUrl;
    this.storename = environment.storename;
    this.Categories(this.storename);
    this.BodySection(this.storename);
  }

  // function calls at finally
  ngAfterViewInit() {
    this.config = {
      slidesPerView: 5,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: 'slide',
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 2
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 3
        },
        1500: {
          slidesPerView: 5
        }
      }
    };
  }

  // Categories
  Categories(i) {
    const params = {
    };
    this.listService.getCategoryList(params).subscribe((res: any) => {
      // console.log('category-->', res.data)
      this.CategoryList = res.data;
    });
  }

  // Body Section
  BodySection(i) {
    const params = {
      storeName: i
    };
    this.listService.getHomeList(params).subscribe((res: any) => {
      // console.log('Home-->', res.data)
      this.home = res.data;
    });
  }
}


